
import React from "react";

import {Link} from "react-router-dom";
const LogoLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader">
   
  
      </div>
    </div>
  );
};
export default LogoLoader;